import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

const PublicSiteHeader = ({ logoTo = '/', children }) => {
  return (
    <header className="ga-safe-top fixed left-0 right-0 top-0 z-50 border-b border-ga-border-subtle bg-ga-bg-surface/80 backdrop-blur-md">
      <div className="mx-auto flex min-h-16 w-full max-w-6xl items-center justify-between px-4 py-2">
        <Link to={logoTo} className="flex items-center">
          <Logo showTagline />
        </Link>
        {children ? <div className="flex items-center gap-3">{children}</div> : null}
      </div>
    </header>
  );
};

export default PublicSiteHeader;
